import { render, staticRenderFns } from "./DocumentPicker.vue?vue&type=template&id=72fddb3e&scoped=true&"
import script from "./DocumentPicker.vue?vue&type=script&lang=js&"
export * from "./DocumentPicker.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPicker.vue?vue&type=style&index=0&id=72fddb3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fddb3e",
  null
  
)

export default component.exports